// src/components/forms/SettingsSlider.js
import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const SettingsSlider = ({ value, ...props }) => {
  return (
    <Slider
      value={value}
      {...props}
      styles={{
        track: { backgroundColor: 'var(--color-primary)' },
        rail: { backgroundColor: 'var(--color-border)' },
        handle: {
          backgroundColor: 'var(--color-background-secondary)',
          borderColor: 'var(--color-primary)',
          borderWidth: 2,
          boxShadow: 'none',
          opacity: 1,
        },
      }}
    />
  );
};

export default SettingsSlider;
